export interface IExtraData {
  customMessageBody?: string;
}

export enum EField {
  CustomMessageBody = "customBody",
}
